import { render, staticRenderFns } from "./FreeSkills.vue?vue&type=template&id=216e14eb&scoped=true&"
import script from "./FreeSkills.vue?vue&type=script&lang=js&"
export * from "./FreeSkills.vue?vue&type=script&lang=js&"
import style0 from "./FreeSkills.vue?vue&type=style&index=0&id=216e14eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216e14eb",
  null
  
)

export default component.exports